import { endpointRegistry } from '../endpointRegistry';
export type RegisteredHttpEndpoint = keyof typeof endpointRegistry;
